import { CNavGroup, CNavItem, CSidebar, CSidebarBrand, CSidebarNav } from '@coreui/react';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import useWindowDimensions from 'hooks/useWindowDimensions';
import { NavItem } from 'layouts/helper';
import routesMap from 'layouts/routesMap';
import React, { useEffect } from 'react';
// import { FaCog, FaLocationArrow, FaCogs } from 'react-icons/fa';
import { FaBox, FaCog, FaSearch } from 'react-icons/fa';
import { HiServer } from 'react-icons/hi';
import { MdSupport } from 'react-icons/md';
import { actionToggleSidebar } from 'redux/appConfig/actions';
import { selectAppSidebarShow } from 'redux/appConfig/selectors';
import SimpleBar from 'simplebar-react';
import 'simplebar/dist/simplebar.min.css';
import { icon } from 'utils/constantImage';
import AppSidebarNav from '../AppSidebarNav';

const _nav: NavItem[] = [
  {
    component: CNavGroup,
    name: 'Tạo đơn',
    // to: routesMap.CAU_HINH_TAI_KHOAN_ROOT,
    icon: <FaBox size={20} style={{ margin: '-3px 8px 0 0' }} color={'#FFFFFF'} />,
    items: [
      {
        component: CNavItem,
        name: 'Tạo đơn lẻ',
        to: routesMap.TAO_DON_LE,
        // icon: <FaCog size={20} style={{ margin: '-3px 8px 0 0' }} />,
      },
      {
        component: CNavItem,
        name: 'Tạo đơn excel',
        to: routesMap.TAO_DON_EXCEL,
        // icon: <FaCog size={20} style={{ margin: '-3px 8px 0 0' }} />,
      },
    ]
  },
  {
    component: CNavGroup,
    name: 'Quản lý',
    to: routesMap.QUAN_LY,
    icon: <HiServer size={20} style={{ margin: '-3px 8px 0 0' }} color={'#FFFFFF'} />,
    items: [
      {
        component: CNavItem,
        name: 'Quản lý đơn hàng',
        to: routesMap.QUAN_LY_DON_HANG,
        // icon: <FaCog size={20} style={{ margin: '-3px 8px 0 0' }} />,
      },
      {
        component: CNavItem,
        name: 'Thống kê tiền hàng',
        to: routesMap.THONG_KE_TIEN_HANG,
        // icon: <FaCog size={20} style={{ margin: '-3px 8px 0 0' }} />,
      },
    ]
  },
  {
    component: CNavGroup,
    name: 'Tra cứu',
    to: routesMap.TRA_CUU,
    icon: <FaSearch size={20} style={{ margin: '-3px 8px 0 0' }} color={'#FFFFFF'} />,
    items: [
      {
        component: CNavItem,
        name: 'Tra cứu cước',
        to: routesMap.UOC_TINH_CUOC,
        // icon: <FaCog size={20} style={{ margin: '-3px 8px 0 0' }} />,
      },
    ]
  },
  {
    component: CNavGroup,
    name: 'Cài đặt',
    to: routesMap.CAU_HINH_TAI_KHOAN_ROOT,
    icon: <FaCog size={20} style={{ margin: '-3px 8px 0 0' }} color={'#FFFFFF'} />,
    items: [
      {
        component: CNavItem,
        name: 'Cấu hình thông tin tài khoản',
        to: routesMap.CAU_HINH_TAI_KHOAN,
        // icon: <FaCog size={20} style={{ margin: '-3px 8px 0 0' }} />,
      },
      {
        component: CNavItem,
        name: 'Cấu hình địa chỉ nhận hàng',
        to: routesMap.CAU_HINH_DIA_CHI_NHAN,
        // icon: <FaLocationArrow size={20} style={{ margin: '-3px 8px 0 0' }} />,
      },
      {
        component: CNavItem,
        name: 'Cấu hình TK thanh toán',
        to: routesMap.CAU_HINH_TAI_KHOAN_THANH_TOAN,
        // icon: <FaCogs size={20} style={{ margin: '-3px 8px 0 0' }} />,
      },
      {
        component: CNavItem,
        name: 'Đổi mật khẩu',
        to: routesMap.DOI_MAT_KHAU,
        // icon: <FaCogs size={20} style={{ margin: '-3px 8px 0 0' }} />,
      },
    ]
  },
  {
    component: CNavGroup,
    name: 'Hỗ trợ',
    to: routesMap.HO_TRO,
    icon: <MdSupport size={20} style={{ margin: '-3px 8px 0 0' }} color={'#FFFFFF'} />,
    items: [
      {
        component: CNavItem,
        name: 'Góp ý - khiếu nại',
        to: routesMap.KHIEU_NAI,
        // icon: <FaCog size={20} style={{ margin: '-3px 8px 0 0' }} />,
      },
    ]
  },
];

const AppSidebar: React.FC = () => {
  const dispatch = useAppDispatch();
  const showSidebar = useAppSelector(selectAppSidebarShow);

  const { width: WIDTH_SCREEN } = useWindowDimensions();

  useEffect(() => {
    if (!showSidebar && WIDTH_SCREEN > 1200) {
      dispatch(actionToggleSidebar(true));
    } else if (showSidebar && WIDTH_SCREEN < 1200) {
      dispatch(actionToggleSidebar(false));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, WIDTH_SCREEN]);

  // const handleVisibleChange = (visible: boolean) => {
  //   dispatch(actionToggleSidebar(visible));
  // };

  return (
    <CSidebar
      position="fixed"
      visible={showSidebar}
      // unfoldable={false}
      // onVisibleChange={handleVisibleChange}
    >
      <CSidebarBrand className="d-none d-md-flex">
        <img style={{cursor: 'pointer', width: 100}} src={icon.icLogo} alt='Ztek' />
        {/* <strong style={{cursor: 'pointer'}}>{'Giao hàng thông minh'}</strong> */}
      </CSidebarBrand>
      <CSidebarNav>
        <SimpleBar>
          <AppSidebarNav items={_nav} />
        </SimpleBar>
      </CSidebarNav>
    </CSidebar>
  );
};

export default AppSidebar;
